module.exports = __webpack_public_path__ + "static/media/battery-tracker.4ccb1595.svg";